import MailboxItem from "./MailboxItem.mjs";

const G = window.glob;

const TemplateItem = class extends MailboxItem {
	onClick(evt) {
		try { evt.preventDefault(); } catch (e) { }
		const m = this.props.data || {};
		delete m.id;
		G.trigger('WriteNewMail', m );
	}
	isMine() { return true; }
	isRead() { return  true; }
	className() { return 'MailboxItem TemplateItem'; }
}

export default TemplateItem;